var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container" }, [
    _c("div", { staticClass: "signup-content" }, [
      _c("h1", { staticClass: "text-uppercase mb-5" }, [
        _vm._v("Sent Verification")
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n      We sent a verification link to your email address: " +
            _vm._s(this.$store.state.userEmail) +
            "\n    "
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "signup-footer" }, [
      _c(
        "button",
        {
          staticClass: "btn btn-primary btn-block btn-lg",
          on: { click: _vm.goToSignin }
        },
        [_vm._v("Return to Sign In")]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1a99048d", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1a99048d","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/SentVerification.vue
// module id = null
// module chunks = 